import { render } from "./EraserTools.vue?vue&type=template&id=efdf4a5c&scoped=true"
import script from "./EraserTools.vue?vue&type=script&lang=js"
export * from "./EraserTools.vue?vue&type=script&lang=js"

import "./EraserTools.vue?vue&type=style&index=0&id=efdf4a5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efdf4a5c"]])

export default __exports__